export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14982.8d406e87.jpg";